import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Mail, ArrowLeft, Check } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Error al procesar la solicitud. Inténtalo de nuevo.');
    }
    
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="forgot-password-success">
        <div className="bg-white rounded-2xl shadow-sm p-8 w-full max-w-md text-center">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
            <Check className="h-8 w-8 text-green-600" />
          </div>
          <h1 className="font-serif text-2xl font-bold text-primary mb-4">¡Revisa tu email!</h1>
          <p className="text-secondary mb-6">
            Si el email <strong>{email}</strong> está registrado en nuestro sistema, 
            recibirás un mensaje con tu nueva contraseña.
          </p>
          <p className="text-sm text-secondary mb-6">
            No olvides revisar la carpeta de spam.
          </p>
          <Link to="/login">
            <Button className="w-full bg-gold hover:bg-gold/90 text-white" style={{ backgroundColor: '#D4A574' }}>
              Volver a Iniciar Sesión
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="bg-white rounded-2xl shadow-sm p-8 w-full max-w-md">
        <Link to="/login" className="flex items-center text-secondary hover:text-gold mb-6">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Volver
        </Link>
        
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(212, 165, 116, 0.1)' }}>
            <Mail className="h-8 w-8 text-gold" style={{ color: '#D4A574' }} />
          </div>
          <h1 className="font-serif text-2xl font-bold text-primary mb-2">¿Olvidaste tu contraseña?</h1>
          <p className="text-secondary">
            Introduce tu email y te enviaremos una nueva contraseña.
          </p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-secondary mb-1">Email</label>
            <Input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              placeholder="tu@email.com"
              required 
              data-testid="forgot-email" 
            />
          </div>
          
          {error && <p className="text-red-500 text-sm">{error}</p>}
          
          <Button 
            type="submit" 
            disabled={loading || !email} 
            className="w-full bg-gold hover:bg-gold/90 text-white" 
            style={{ backgroundColor: '#D4A574' }} 
            data-testid="forgot-submit"
          >
            {loading ? 'Enviando...' : 'Enviar nueva contraseña'}
          </Button>
        </form>

        <p className="text-center text-secondary text-sm mt-6">
          ¿Recordaste tu contraseña?{' '}
          <Link to="/login" className="text-gold hover:underline" style={{ color: '#D4A574' }}>
            Iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
